import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { useHistory } from "react-router-dom";
import localeText from "../../../../../../locale";
import "./ProductTypeModal.css";

export const PRODUCT_TYPE_QUERY = {
  physical: "physical",
  service: "service",
  digital: "digital",
};

export const PRODUCT_TYPE_VALUE = {
  physical: 1,
  service: 2,
  digital: 3,
};

export const queryToProductType = (query) => PRODUCT_TYPE_VALUE[query] || null;

export const productTypeToQuery = (value) => {
  if (value === 2) return PRODUCT_TYPE_QUERY.service;
  if (value === 3) return PRODUCT_TYPE_QUERY.digital;
  if (value === 1) return PRODUCT_TYPE_QUERY.physical;
  return null;
};

const OPTIONS = [
  {
    value: PRODUCT_TYPE_QUERY.physical,
    titleKey: "productTypePhysical",
    descKey: "productTypePhysicalDesc",
  },
  {
    value: PRODUCT_TYPE_QUERY.service,
    titleKey: "productTypeService",
    descKey: "productTypeServiceDesc",
  },
  {
    value: PRODUCT_TYPE_QUERY.digital,
    titleKey: "productTypeDigital",
    descKey: "productTypeDigitalDesc",
  },
];

function ProductTypeModal({ visible, onHide }) {
  const history = useHistory();
  const [selected, setSelected] = useState(PRODUCT_TYPE_QUERY.physical);

  const handleSelect = (value) => {
    setSelected(value);
    history.push(`/dashboard-store/products/new?type=${value}`);
    onHide?.();
  };

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      closable
      draggable={false}
      modal
      className="product-type-modal"
      header={localeText("productTypeModalTitle")}
      style={{ width: "min(520px, 94vw)" }}
    >
      <div className="product-type-modal-list">
        {OPTIONS.map((option) => {
          const isSelected = selected === option.value;
          return (
            <button
              key={option.value}
              type="button"
              className={`product-type-card${isSelected ? " is-selected" : ""}`}
              onClick={() => handleSelect(option.value)}
            >
              <div>
                <p className="product-type-card-title">{localeText(option.titleKey)}</p>
                <p className="product-type-card-desc">{localeText(option.descKey)}</p>
              </div>
              <span className={`product-type-radio${isSelected ? " is-selected" : ""}`} />
            </button>
          );
        })}
      </div>
    </Dialog>
  );
}

export default ProductTypeModal;
